<template>
  <PuSkeleton :loading="isLoading" :count="1" width='100%' height="240px">                
    <line-chart :chartdata="chart"/>
  </PuSkeleton>
</template>


<script>
import lineChart from '../chart/LineBig'
//
export default {
  name: "CardBig",
  components:{ 
    lineChart
  },
  data(){
    return {
      isLoading:true,
      chart : {
              labels: [4,5,6,7],
              datasets: [{ 
                  data: [86,114,106,106,107],
                  borderColor: "rgb(0,106,162)",
                  fill: false,
                  borderDash: [5,10],
                  pointRadius: 0
                }, { 
                  data: [182,150,211,202,235],
                  borderColor: "rgb(128,128,128)",
                  fill: false,
                  pointRadius: 0
                }, { 
                  data: [168,170,178,190,203],
                  borderColor: "rgb(0,106,162)",
                  fill: false,
                  pointRadius: 0
                }
              ]
      }
    }
  },
   created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  } 
}
</script>